// extracted by mini-css-extract-plugin
export var footer = "_n7-5";
export var fulfillmentInput = "_n7-0";
export var shipDateInput = "_n7-1";
export var shipmentModal = "_n7-2";
export var shipmentModalContent = "_n7-3";
export var tableContainer = "_n7-4";